export function sourceIdsMatch(a, b) {
  return a != null && b != null && String(a) === String(b);
}

/** Mantém a fonte recém-criada visível sem reordenar as restantes. */
export function mergeSourceIntoList(list, source) {
  if (!source?.id) return list;
  if (list.some((item) => sourceIdsMatch(item.id, source.id))) {
    return list;
  }
  return [...list, source];
}

const PREVIEW_SOURCE_LIMIT = 8;

/**
 * Primeiras N fontes na ordem da API — sem mover a selecionada para a frente.
 */
export function splitSourcesForPreview(allSources) {
  const preview = allSources.slice(0, PREVIEW_SOURCE_LIMIT);
  const previewIds = new Set(preview.map((s) => String(s.id)));
  const extra = allSources.filter((s) => !previewIds.has(String(s.id)));
  return { preview, extra };
}

export function suggestedAmountForSource(source) {
  if (
    source?.base_amount === null ||
    source?.base_amount === undefined ||
    source?.base_amount === ''
  ) {
    return '';
  }
  return String(source.base_amount).replace('.', ',');
}
